<template>
  <v-container v-if="$auth.isAuthenticated()" fluid bg fill-height>
    <v-row justify="center">
      <h2 class="white--text">{{
          (help_provider !== 'null' ? JSON.parse(help_provider).name : $t(translation + ".azzk"))
        }}
      </h2>
    </v-row>
    <v-row class="mt-3" justify="center">
      <v-row class="mx-5" justify="center" style="max-width: 1400px">
        <card v-for="page in this.pages"
              v-if="hasPermissionToViewLink(page)"
              :key="page.to"
              :text="page.text"
              :to="page.to"
              :icon="page.icon"
              :is_link="page.is_link"
              class="primary"
              :has-round-corners="true"
              :has-box-shadow="true"
        />
      </v-row>
    </v-row>

    <v-toolbar
      v-if="hasPermissionToViewLink({roles: [1,2]})"
      class="mt-5"
      color="primary">
      <v-row justify="center" align="center">
        <h2 class="white--text mr-6">
          {{ $t(translation + '.statistics') }}
        </h2>
        <v-tooltip top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              :loading="tableDataLoading"
              :disabled="tableDataLoading"
              v-bind="attrs"
              v-on="on"
              class="warning ml-6"
              @click="readStats()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('tooltips.refresh') }}</span>
        </v-tooltip>
      </v-row>
    </v-toolbar>
    <v-row
      v-if="hasPermissionToViewLink({roles: [1,2]})"
      justify="center"
      class="mt-1">
      <v-data-table
        :mobile-breakpoint="0"
        dark
        :headers="headers"
        :items="tableData"
        :dense="true"
        :loading-text="$t('loading_data')"
        class="elevation-1 secondary white--text"
        sort-by="name"
        :loading="tableDataLoading"
        hide-default-footer
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <th
            v-for="head in headers"
            style="font-size: medium;"
            :class="getHeaderClass(head.name)"
          >
            {{ head.text }}
          </th>
        </template>
        <template v-slot:item.name="{ item }">
          <div
            class="transparent py-2 mx-3"
            style="font-size: large"
          >
            {{ item.name }}
          </div>
        </template>
        <template v-slot:item.accepted="{ item }">
          <v-btn
            class="transparent py-2 my-3 justify-end green--text"
            style="font-size: large; width: 100% !important"
            @click="openPage(item.acceptedLink)"
          >
            {{ item.accepted }}
          </v-btn>
        </template>
        <template v-slot:item.inserted="{ item }">
          <v-btn
            :class="'transparent py-2 justify-end' + (item.inserted > 0 ? ' warning--text' : '')"
            style="font-size: large; width: 100% !important"
            @click="openPage(item.insertedLink)"
          >
            {{ item.inserted }}
          </v-btn>
        </template>
        <template v-slot:item.rejected="{ item }">
          <v-btn
            :class="'transparent py-2 justify-end' + (item.rejected > 0 ? ' error--text' : '')"
            style="font-size: large; width: 100% !important"
            @click="openPage(item.rejectedLink)"
          >
            {{ item.rejected }}
          </v-btn>
        </template>
        <!-------------------------------- ## NO DATA ## ----------------------------------->
        <template v-slot:no-data>
          <div class="text-xs-center">
            <v-alert color="error" icon="mdi-alert-circle-outline">
              {{ errorMessage }}
            </v-alert>
          </div>
        </template>
      </v-data-table>
    </v-row>

  </v-container>
</template>

<script>
import Card from '../components/portal/Cards'
import {EventBus} from "../event-bus";
import {readTableData} from "../statics/DataTableFunctions";

export default {
  components: {
    'card': Card,
  },
  data() {
    return {
      name: localStorage.getItem('name'),
      help_provider: localStorage.getItem('cb_help_provider'),
      translation: 'dashboard',
      roles: JSON.parse(localStorage.getItem('roles')) ? JSON.parse(localStorage.getItem('roles')).map(role => role.id) : [],
      tableDataLoading: false,
      tableData: [],
      filteredTableData: [],
      filters: [],
      errorMessage: this.$t('no_data'),
      pages: [
        {
          to: '/management',
          is_link: false,
          icon: 'mdi-menu',
          text: this.$t('drawer.management'),
          roles: [1, 2]
        },
        {
          to: '/help_registries/de_minimis',
          is_link: false,
          icon: 'mdi-view-agenda-outline',
          text: this.$t('help_registries.de_minimis.header'),
          roles: [1, 2, 3]
        },
        {
          to: '/help_registries/covid',
          is_link: false,
          icon: 'mdi-virus-outline',
          text: this.$t('help_registries.covid.header'),
          roles: [1, 2, 3]
        },
        {
          to: '/help_registries/general',
          is_link: false,
          icon: 'mdi-view-agenda',
          text: this.$t('help_registries.general.header'),
          roles: [1, 2, 3]
        },
        {
          to: '/help_registries/returned',
          is_link: false,
          icon: 'mdi-recycle',
          text: this.$t('help_registries.returned.header'),
          roles: [1, 2, 3]
        },
      ],
    }
  },
  methods: {
    readTableData,
    getHeaderClass(name) {
      switch (name) {
        case "accepted":
          return 'green--text';
        case "inserted":
          return 'warning--text';
        case 'rejected':
          return 'error--text';
        default:
          return 'white--text'
      }
    },
    hasPermissionToViewLink(link) {
      return link.roles.some(r => this.roles.includes(r));
    },
    openPage(link) {
      EventBus.$emit('externalOpenLink', {
        link: link,
        openDrawer: false
      });
      this.$router.push(link)
    },
    readStats() {
      this.readTableData('help_registries/dashboard')
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t(this.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t(this.translation + '.accepted'),
          name: 'accepted',
          align: 'right',
          value: 'accepted'
        },
        {
          text: this.$t(this.translation + '.inserted'),
          name: 'inserted',
          align: 'right',
          value: 'inserted'
        },
        {
          text: this.$t(this.translation + '.rejected'),
          name: 'rejected',
          align: 'right',
          value: 'rejected'
        }
      ];
    },
  },
  created() {
    if (!this.$auth.isAuthenticated()) {
      this.$router.push('/login')
    }
    if (this.hasPermissionToViewLink({roles: [1, 2]})) {
      this.readStats();
    }

  }
}
</script>

<style>
.v-content__wrap {
  /*background-image: url('../assets/background.jpg');*/
  /*background-image: url('../assets/background.svg');*/
  /*min-height: max-content;*/

  /*background-color: #0d0d0d;*/
  /*background-repeat: no-repeat;*/
  /*background-size: contain;*/
  /*background-position: bottom;*/

  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('../assets/pattern.jpg') repeat;
  background-size: contain;
}
</style>
